export default class Donation
{
    constructor($el, options = {}) {
        this.DOM = { $el }
        this.options = { ...Donation.prototype.defaults, ...options }
        this.init()
    }

    init() {
        this.DOM.$$radio = this.DOM.$el.querySelectorAll('input[type="radio"]')
        this.DOM.$other = this.DOM.$el.querySelector(this.options.selectorOther)
        this.DOM.$otherInput = this.DOM.$el.querySelector(this.options.selectorOtherInput)
        this.DOM.$submit = document.querySelector(this.options.selectorSubmit)
        this.DOM.$name = this.DOM.$el.querySelector(this.options.selectorNameInput);
        this.DOM.$email = this.DOM.$el.querySelector(this.options.selectorEmailInput);

        this.DOM.$$radio.forEach($radio => {
            $radio.addEventListener('change', this.onRadioClick.bind(this), { passive: true })
        })

        this.DOM.$otherInput.addEventListener('focus', this.onFocusOtherInput.bind(this), { passive: true })
    }

    onFocusOtherInput() {
        this.DOM.$other.checked = true
        this.DOM.$other.dispatchEvent(new Event('change'))
        this.DOM.$submit.innerHTML = 'Continue to payment';
        this.DOM.$name.setAttribute('required', 'required');
        this.DOM.$email.setAttribute('required', 'required');
    }

    onRadioClick(e) {
        this.DOM.$el.classList.toggle(this.options.classNameIsDonating, (e.target.value !== '0'))
        if(this.DOM.$el.classList.contains(this.options.classNameIsDonating)){
            this.DOM.$submit.innerHTML = 'Continue to payment';
            this.DOM.$name.setAttribute('required', 'required');
            this.DOM.$email.setAttribute('required', 'required');
        }else{
            this.DOM.$submit.innerHTML = 'Submit';
            this.DOM.$name.removeAttribute('required');
            this.DOM.$email.removeAttribute('required');
        }
    }
}

Donation.prototype.defaults = {
    classNameIsDonating: 'is-donating',
    selectorOther: '.js-donationOther',
    selectorOtherInput: '.js-donationOtherInput',
    selectorSubmit: '.js-submitSurvey',
    selectorNameInput: '#name',
    selectorEmailInput: '#email',
}